import { useState } from "react";
import { Outlet } from "react-router-dom";

const MARKETING_PASSWORD = "medtechos2026";

export function MarketingGate() {
  const [unlocked, setUnlocked] = useState(() => {
    return sessionStorage.getItem("marketing_unlocked") === "true";
  });
  const [password, setPassword] = useState("");
  const [error, setError] = useState(false);

  function handleSubmit() {
    if (password === MARKETING_PASSWORD) {
      sessionStorage.setItem("marketing_unlocked", "true");
      setUnlocked(true);
    } else {
      setError(true);
    }
  }

  if (unlocked) return <Outlet />;

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="w-full max-w-sm space-y-4 text-center p-8">
        <h1 className="text-2xl font-bold text-foreground">Medtech-OS</h1>
        <p className="text-sm text-muted-foreground">This site is not yet public. Enter the preview password to continue.</p>
        <input
          type="password"
          value={password}
          onChange={(e) => { setPassword(e.target.value); setError(false); }}
          onKeyDown={(e) => e.key === "Enter" && handleSubmit()}
          placeholder="Preview password"
          autoFocus
          className="w-full rounded-md border border-input bg-background px-4 py-2 text-center text-sm focus:outline-none focus:ring-2 focus:ring-ring"
        />
        {error && <p className="text-sm text-red-500">Wrong password</p>}
        <button onClick={handleSubmit}
          className="w-full rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90">
          Enter
        </button>
        <a href="/login" className="text-sm text-primary hover:underline">
          Already have an account? Sign in →
        </a>
      </div>
    </div>
  );
}
